import { render, staticRenderFns } from "./ProductLocalCustomersFormItems.vue?vue&type=template&id=0092dbda&"
import script from "./ProductLocalCustomersFormItems.vue?vue&type=script&lang=js&"
export * from "./ProductLocalCustomersFormItems.vue?vue&type=script&lang=js&"
import style0 from "./ProductLocalCustomersFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0092dbda')) {
      api.createRecord('0092dbda', component.options)
    } else {
      api.reload('0092dbda', component.options)
    }
    module.hot.accept("./ProductLocalCustomersFormItems.vue?vue&type=template&id=0092dbda&", function () {
      api.rerender('0092dbda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductLocalCustomersFormItems.vue"
export default component.exports